<script>
export default {
  provide() {
    return {
      staticsScope: this.scope
    };
  },

  props: {
    scope: { required: true, type: String }
  },

  render(createElement) {
    return this.$slots.default;
  }
};
</script>
